import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useEffect, useRef, useState } from 'react'

import { AuthContext } from './auth-context'

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const queryClient = useQueryClient()
  const queryClientRef = useRef(queryClient)
  const [token, setToken] = useState<string | null>(localStorage.getItem('site'))

  useEffect(() => {
    if (token === null) {
      // when the token changes, clear the query cache
      queryClientRef.current.clear()
    }
  }, [token])

  const login = (token: string) => {
    setToken(token)
    localStorage.setItem('site', token)
  }

  const logOut = useCallback(() => {
    setToken(null)
    localStorage.removeItem('site')
  }, [])

  return (
    <AuthContext.Provider
      value={{
        token,
        isAuthenticated: !!token,
        login,
        logOut,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider
